import { GAME_DIV_ID, GAME_WIDTH_DEFAULT, GAME_HEIGHT_DEFAULT } from 'app/constants/AppConstants';

export default {
  type: Phaser.CANVAS,
  parent: GAME_DIV_ID,
  width: GAME_WIDTH_DEFAULT,
  height: GAME_HEIGHT_DEFAULT,
};
